import React from "react";
import Navbar from "../Nav/Nav";
import Banner from "./Banner";
const RedirectLink = () => {
  return (
    <div className="redirect">
      <Navbar />
      <Banner />
    </div>
  );
};
export default RedirectLink;
